<template>
  <div class="vip-pane">
    <el-dialog title="开通VIP特权" custom-class="vip-pane-modal" :visible.sync="paneShow" width="1170px" append-to-body>
      <div class="vip-pane" v-loading="initLoading">
        <div class="vip-pane-tab-ul">
          <div class="vip-pane-tab-li" v-for="(tabItem, tabIdx) in tabArr" :key="tabIdx"
            :class="curTabItem === tabItem && 'is-active'" @click="curTabItem = tabItem">
            <span>{{ tabItem.label }}</span>
          </div>
        </div>

        <div class="vip-content">
          <div class="vip-flex-left">
            <div class="vip-pane-product-ul" v-if="curTabItem">
              <div v-for="productItem in curTabItem.productList" :key="productItem.id" class="vip-pane-product-li"
                :class="curProductItem === productItem && 'is-active'" @click="curProductItem = productItem">
                <div class="vip-pane-product-label">
                  {{ productItem.label }}
                </div>
                <div class="vip-pane-product-price">
                  <div>
                    <span>￥</span>
                    <span class="vip-pane-product-price-num">
                      {{ productItem.payPrince }}
                    </span>
                    <div class="vip-pane-product-first-prince" v-if="productItem.payPrince !== productItem.firstPrince">
                      ￥{{ productItem.firstPrince }}
                    </div>
                    <div class="vip-pane-product-coupon-tip" v-if="productItem.couponDiscountPrice">
                      <span>预估折后到手：￥{{ productItem.couponDiscountPrice.toLocaleString() }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="vip-pay-content">
              <div class="product-order-info">
                <div class="qrcode-content">
                  <div id="qrcode" ref="qrcode"></div>
                  <div class="argee-mask" v-show="!agree">
                    <div>请先勾选右</div>
                    <div>方使用协议</div>
                  </div>
                </div>
                <div class="order-info-content">
                  <div class="order-price">
                    <span>应付金额：</span>
                    <span class="price-num">￥{{ payPrice.toLocaleString() }}</span>
                    <span v-if="couponEntities.length > 0" class="coupon-card-desc">
                      <span>已使用</span>
                      <span>{{ couponEntities | couponFilter }}</span>
                      <span>折卡</span>
                    </span>
                  </div>
                  <div class="order-tip">
                    <img class="wechat-img" :src="wechatImg" />
                    <span>微信扫码支付</span>
                    <span class="price-tip">支付后可自助开具发票</span>
                  </div>
                  <div @click="agree = !agree" :style="{ marginTop: '12px', cursor: 'pointer' }">
                    <span class="el-radio" :style="{ marginRight: '5px' }">
                      <span class="el-radio__input" :class="agree ? 'is-checked' : ''">
                        <span class="el-radio__inner"></span>
                      </span>
                    </span>
                    <span>我已阅读并同意</span>
                    <a :style="{ color: '#3f6efc', textDecoration: 'none' }" @click.stop="downloadCb"
                      href="https://xiaobaogong-small-program.oss-cn-shenzhen.aliyuncs.com/小包公用户注册服务协议.docx">《用户注册服务协议》</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ICON列表 -->
          <template v-if="curProductItem">
            <div class="vip-privilege-container" v-for="(vipTipItem, vipTipIdx) in curProductItem.tipArr"
              :key="vipTipIdx">
              <div class="vip-privilege-title">
                <div>{{ vipTipItem.label }}VIP</div>
                <div class="vip-privilege-tip">无限制多项特权</div>
              </div>
              <div class="vip-privilege-list">
                <div class="vip-privilege-item" v-for="tipText in vipTipItem.tips" :key="tipText">
                  <img class="vip-privilege-icon" :src="iconList[tipText]" />
                  <span class="vip-privilege-text">{{ tipText }}</span>
                </div>
              </div>
            </div>
          </template>
          <!-- <div v-if="curProductItem" class="vip-pane-table-container">
            <div class="vip-pane-table is-head">
              <div
                class="vip-pane-table-group"
                v-if="curProductItem.tipArr.length > 1"
              ></div>
              <div class="vip-pane-table-tip-ul">权益</div>
              <div class="vip-pane-table-vip-check">VIP用户</div>
              <div class="vip-pane-table-normal">普通用户</div>
            </div>
            <div
              class="vip-pane-table"
              v-for="(vipTipItem, vipTipIdx) in curProductItem.tipArr"
              :key="vipTipIdx"
            >
              <div
                class="vip-pane-table-group"
                v-if="curProductItem.tipArr.length > 1"
              >
                {{ vipTipItem.label }}
              </div>
              <div class="vip-pane-table-tip-ul">
                <div
                  class="vip-pane-table-tip-li"
                  v-for="tipText in vipTipItem.tips"
                  :key="tipText"
                >
                  {{ tipText }}
                </div>
              </div>
              <div class="vip-pane-table-vip-check">
                <div
                  class="vip-pane-table-vip-check-li"
                  v-for="tipText in vipTipItem.tips"
                  :key="tipText"
                >
                  <i class="el-icon-check"></i>
                </div>
              </div>
              <div class="vip-pane-table-normal">
                <span>{{ vipTipItem.freeLimit }}次免费体验</span>
              </div>
            </div>
          </div> -->

          <!-- <div class="vip-pane-tools" v-if="curProductItem">
          <el-button type="primary" @click="(orderShow = true), (paneShow = false)">
            <span>开通VIP</span>
          </el-button>
        </div> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { services } from "@/service";
import vipOrder from "./vipOrder.vue";
import QRCode from "qrcodejs2";

import generalSearchImg from "@/assets/普通检索@2x.png";
import advancedSearchImg from "@/assets/高级检索@2x.png";
import resSearchImg from "@/assets/结果中检索@2x.png";
import detailImg from "@/assets/明细@2x.png";
import downloadImg from "@/assets/下载2@2x.png";
import reportGenerateImg from "@/assets/报告生成@2x.png";
import reportDownloadImg from "@/assets/报告下载@2x.png";
import wechatImg from "@/assets/微信支付@2x.png";

export default {
  components: { vipOrder },
  data() {
    return {
      payPrice: 0,
      agree: false,
      paneShow: true,
      orderShow: false,
      initLoading: false,
      tabArr: [],
      curTabItem: null,
      curProductItem: null,
      iconList: {
        普通检索: generalSearchImg,
        高级检索: advancedSearchImg,
        结果中检索: resSearchImg,
        类案明细: detailImg,
        类案下载: downloadImg,
        检索报告生成: reportGenerateImg,
        检索报告下载: reportDownloadImg,
        法律法规明细: detailImg,
        法律法规下载: reportDownloadImg,
        "类案+法律普通检索": generalSearchImg,
        "类案+法律高级检索": advancedSearchImg,
        "类案+法律结果中检索": resSearchImg,
        "类案+法律明细": detailImg,
        "类案+法律下载": downloadImg,
        类案检索报告生成: reportGenerateImg,
        类案检索报告下载: reportDownloadImg,
      },
      wechatImg,
      timeoutController: 0,
      initLoading: false,
      orderId: "",
      orderNumber: "-",
      count: 0,
      createTime: 0,
      spreadPrice: 0,
      agree: false,
      couponEntities: []
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    vipType: {
      type: String,
      required: true,
      validator: (val) => ["law", "case"].includes(val),
    },
  },
  computed: {
    visible() {
      return this.paneShow || this.orderShow;
    },
  },
  filters: {
    couponFilter(couponEntities) {
      return couponEntities[0].discount;
    }
  },
  watch: {
    curProductItem() {
      this.getOrderInfo();
    },
    visible(val) {
      if (!val) {
        this.$emit("update:show", val);
      }
    },
    curTabItem(val) {
      const idx = val.productList.findIndex((o) => o.isRecommend);
      this.curProductItem = val.productList[idx !== -1 ? idx : 0];
    },
  },
  mounted() {
    this.getProductInfo();
  },
  methods: {
    async getProductInfo() {
      try {
        this.initLoading = true;
        const purpose = this.vipType === "law" ? "PC_法律法规" : "PC_类案";
        const result = await services.vip.getVipProducts(purpose);
        if (result.statusCode !== 1) {
          throw new Error(result.message);
        }
        const caseVipArr = [
          "普通检索",
          "高级检索",
          "结果中检索",
          "类案明细",
          "类案下载",
          "检索报告生成",
          "检索报告下载",
        ];
        const lawVipArr = [
          "普通检索",
          "高级检索",
          "结果中检索",
          "法律法规明细",
          "法律法规下载",
        ];
        const caseAndLaw = [
          "类案+法律普通检索",
          "类案+法律高级检索",
          "类案+法律结果中检索",
          "类案+法律明细",
          "类案+法律下载",
          "类案检索报告生成",
          "类案检索报告下载",
        ];
        const tabMap = new Map();
        result.data.forEach((item) => {
          let purposeStr = item.purpose.map((text) => text.slice(3)).join("+");
          if (item.purpose.length > 1) {
            purposeStr = `${purposeStr} 组合VIP`;
          } else {
            purposeStr = `${purposeStr}VIP`;
          }

          item.label = `${item.name.match(/（\d+天）/)[0].slice(1, -1)}特权`;
          item.isRecommend = !!item.name.match(/（360天）/);
          const isCase = !!item.name.match("类案");
          const isLaw = !!item.name.match("法律法规");
          if (isCase && isLaw) {
            item.tipArr = [{ label: "类案+法律法规", tips: caseAndLaw }];
          } else if (isCase) {
            item.tipArr = [
              { label: "类案分析", tips: caseVipArr, freeLimit: 100 },
            ];
          } else if (isLaw) {
            item.tipArr = [
              { label: "法律法规", tips: lawVipArr, freeLimit: 200 },
            ];
          } else {
            item.tipArr = [];
          }

          const tabItem = tabMap.get(purposeStr);
          if (tabItem) {
            tabItem.productList.push(item);
          } else {
            tabMap.set(purposeStr, { label: purposeStr, productList: [item] });
          }
        });
        this.tabArr = [...tabMap.entries()].map((o) => o[1]);
        this.tabArr.forEach((item) => {
          item.productList = item.productList.sort(
            (a, b) => a.payPrince - b.payPrince
          );
        });
        const groupItem = this.tabArr.find((o) => !o.label.includes('组合VIP'));
        this.curTabItem = groupItem || this.tabArr[0];
      } catch (err) {
        // this.$message.error(err.message);
      } finally {
        this.initLoading = false;
      }
    },
    // 支付订单相关
    downloadCb() {
      setTimeout(() => {
        this.$message.success("下载成功");
      }, 500);
    },
    clearTimeoutHandle() {
      if (this.timeoutController) {
        clearTimeout(this.timeoutController);
      }
    },
    async getOrderInfo() {
      try {
        this.clearTimeoutHandle();
        this.initLoading = true;

        const params = {
          productId: this.curProductItem.id,
          body: `小包公-${this.curProductItem.name}`,
          platform: 'pay_platform_company'
        };

        const result = await services.vip.createOrder(params);
        if (result.statusCode !== 1) {
          throw new Error(result.message);
        }

        const { orderInfo, unifiedOrder } = result.data;
        this.clearPayImg();
        new QRCode("qrcode", {
          width: 108,
          height: 108,
          text: unifiedOrder.codeUrl,
        });
        this.payPrice = orderInfo.realPrice;
        this.spreadPrice = orderInfo.spreadPrice || 0;
        this.couponEntities = orderInfo.couponEntities || [];
        this.orderId = unifiedOrder.orderId;
        this.createTime = Number(unifiedOrder.timeStamp) * 1000;
        this.orderNumber = unifiedOrder.orderNumber;
        this.checkOrderHandle();
      } catch (err) {
        // this.$error(err);
      } finally {
        this.initLoading = false;
      }
    },
    checkOrderHandle() {
      const orderId = this.orderId;
      if (!orderId) {
        return;
      }
      this.clearTimeoutHandle();
      this.timeoutController = setTimeout(async () => {
        try {
          const result = await services.vip.checkOrder(orderId);
          if (result.statusCode !== 1) {
            throw new Error(result.message);
          }
          const { status } = result.data;
          if (status !== "SUCCESS") {
            this.checkOrderHandle();
            return;
          }
          this.$message.success("支付成功");
          location.reload();
        } catch (err) {
          this.clearPayImg();
          // this.$error(err);
        }
      }, 1500);
    },
    clearPayImg() {
      const qrcodeEl = document.getElementById("qrcode");
      qrcodeEl && (qrcodeEl.innerHTML = "");
    },
  },
  beforeDestroy() {
    this.clearTimeoutHandle();
  },
};
</script>

<style lang="less">
.vip-pane-modal {
  .el-dialog__header {
    position: relative;
    border-bottom: 0;
    background-color: #3f6efc;
    padding: 14px 24px;

    .el-dialog__headerbtn {
      top: 18px;
      z-index: 2;

      .el-dialog__close {
        color: #fff;
      }
    }

    .el-dialog__title {
      color: #fff;
    }
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 686px;
    height: 52px;
    background: url("../assets/orderModalHeaderImg.png") no-repeat;
    background-size: cover;
    z-index: 1;
  }
}
</style>
<style lang="less" scoped>
@borderColor: #f1f2f6;

.vip-pane {
  min-height: 400px;
  // padding: 0 10px;

  .vip-content {
    padding: 30px;
    display: flex;
  }

  .vip-pane-tools {
    margin-top: 35px;

    .el-button {
      width: 100%;
      background-color: #3f6efc !important;
      border-color: #3f6efc !important;
    }
  }

  .vip-pane-table-container {
    min-height: 200px;
    max-height: calc(100vh - 15vh - 50px - 400px);
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .vip-pane-table {
    display: flex;
    font-size: 16px;
    color: #172237;
    border: 1px solid @borderColor;
    border-top: 0;

    &:first-child {
      border-top: 1px solid @borderColor;
    }

    &>div {
      text-align: center;
    }

    .vip-pane-table-group {
      box-sizing: border-box;
      width: 50px;
      padding: 0 15px;
      border-right: 1px solid @borderColor;
      font-weight: bold;
      writing-mode: vertical-lr;
    }

    .vip-pane-table-tip-ul {
      flex: 1;

      .vip-pane-table-tip-li {
        height: 50px;
        line-height: 50px;
      }
    }

    .vip-pane-table-vip-check {
      width: 216px;

      .vip-pane-table-vip-check-li {
        height: 50px;
        line-height: 50px;
        color: #3f6efc;
        background-color: #f3f9ff;
      }
    }

    .vip-pane-table-normal {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.is-head {
      margin-top: 32px;

      &>div {
        height: 50px;
        line-height: 50px;
        font-weight: bold;
        background-color: #f7f7f7;
      }

      .vip-pane-table-vip-check {
        color: #fff;
        background-color: #3f6efc;
      }
    }
  }

  .vip-flex-left {
    display: flex;
    flex-direction: column;
    // flex: 1;
    width: 770px;
  }

  .vip-pane-product-ul {
    display: flex;
    // margin-top: 40px;
    // width: 600px;

    .vip-pane-product-li {
      position: relative;
      box-sizing: border-box;
      overflow: hidden;
      flex: 1;
      margin-left: 12px;
      border-radius: 4px;
      cursor: pointer;

      &:first-child {
        margin-left: 0;
      }

      .vip-pane-product-label {
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        padding: 14px;
      }

      .vip-pane-product-price {
        box-sizing: border-box;
        height: 146px;
        text-align: center;
        color: #e42626;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid @borderColor;
        border-radius: 0 0 4px 4px;
        border-top: none;
        font-weight: 600;
        position: relative;

        .vip-pane-product-price-num {
          font-size: 32px;
          font-weight: bold;
        }

        .vip-pane-product-first-prince {
          color: #555457;
          text-decoration: line-through;
          margin-top: 7px;
        }

        .vip-pane-product-coupon-tip {
          font-size: 12px;
          line-height: 17px;
          color: #E47826;
          margin-top: 10px;
        }
      }

      &.is-active .vip-pane-product-price {
        border: 1px solid #3f6efc;
        background-color: #f3f8ff;
        border-top: none;

        &::after {
          background: url("../assets/选中@2x.png");
          background-size: 100% 100%;
          content: " ";
          // 设置0的话，切图右下角会有白边
          right: -1px;
          bottom: -1px;
          width: 28px;
          height: 22px;
          display: block;
          position: absolute;
          z-index: 100;
        }
      }
    }
  }

  .vip-pay-content {
    margin-top: 15px;
    height: 220px;
    border-radius: 4px;
    border: 1px solid @borderColor;

    .el-radio {
      .el-radio__inner {
        width: 16px;
        height: 16px;
        border-width: 2px;
      }
    }

    .product-desc-limit {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .product-desc {
      color: #9599a5;
      font-size: 14px;
      line-height: 20px;
      margin-top: 15px;

      .desc-price {
        color: #172237;
      }
    }

    .product-limit {
      color: #9599a5;
      margin-top: 15px;
    }

    .product-order-info {
      display: flex;
      justify-content: center;
      align-items: center;
      // align-items: flex-start;
      min-height: 120px;
      margin-top: 50px;
      color: #172237;
      font-size: 14px;
      line-height: 20px;

      .qrcode-content {
        position: relative;
        box-sizing: border-box;
        width: 120px;
        height: 120px;
        padding: 5px;
        border: 1px solid #dbdfe9;

        #qrcode {
          width: 100%;
        }

        .argee-mask {
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          color: #fff;
          text-align: center;
          font-size: 16px;
          line-height: 24px;
          padding-top: 36px;
          background-color: rgba(0, 0, 0, 0.8);
          z-index: 1;
        }
      }

      .order-info-content {
        box-sizing: border-box;
        // flex: 1;
        // width: 0;
        color: #4e555b;
        font-size: 14px;
        margin-left: 14px;

        .order-tip {
          margin-top: 12px;

          .wechat-img {
            position: relative;
            top: 1px;
            height: 16px;
            margin-right: 4px;
          }
        }

        .order-price {
          // margin-top: 12px;
          vertical-align: bottom;

          .price-num {
            color: #ee3131;
            font-size: 24px;
            font-weight: 600;
            line-height: 28px;
          }

          .coupon-card-desc {
            position: relative;
            top: -2px;
            color: #fff;
            font-size: 14px;
            line-height: 20px;
            border-radius: 4px;
            background-color: #e47826;
            padding: 4px 8px;
            margin-left: 20px;
          }

        }
        .price-tip {
          color: #9599a5;
          font-size: 12px;
          margin-left: 16px;
        }
        .order-time {
          margin-top: 16px;
        }
      }
    }
  }

  // 特权标头背景图
  .vip-pane-product-li:nth-child(1) .vip-pane-product-label {
    background: url("../assets/30底纹@2x.png");
    background-size: 100% 100%;
  }

  .vip-pane-product-li:nth-child(2) .vip-pane-product-label {
    background: url("../assets/180@2x.png");
    background-size: 100% 100%;
  }

  .vip-pane-product-li:nth-child(3) .vip-pane-product-label {
    background: url("../assets/360@2x.png");
    background-size: 100% 100%;
  }

  .vip-pane-product-li:nth-child(4) .vip-pane-product-label {
    background: url("../assets/720@2x.png");
    background-size: 100% 100%;
  }

  // vip特权
  .vip-privilege-container {
    border: 1px solid @borderColor;
    border-radius: 4px;
    // width: 310px;
    flex: 1;
    padding: 20px 0;
    margin-left: 15px;
    cursor: default;

    .vip-privilege-title {
      margin: 0 10px;
      display: flex;
      flex-wrap: wrap;
      color: #000;
      font-weight: 500;

      .vip-privilege-tip {
        margin-left: 12px;
        color: #3f6efc;
      }
    }

    .vip-privilege-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .vip-privilege-item {
        width: 50%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;
        margin: 30px auto 0;
        color: #4e555b;

        .vip-privilege-icon {
          width: 40px;
          height: 40px;
          margin-bottom: 8px;
        }

        .vip-privilege-text {
          font-size: 14px;
        }
      }
    }

    .vip-privilege-list:after {
      content: " ";
      width: 50%;
      height: 0;
      display: block;
    }
  }

  .vip-pane-tab-ul {
    color: #172237;
    font-size: 16px;
    background-color: #f5f4f9;
    display: flex;

    .vip-pane-tab-li {
      padding: 20px 60px;
      cursor: pointer;
      position: relative;

      &:first-child {
        margin-left: 0;
      }

      &.is-active {
        &>span {
          font-weight: 500;
        }

        background-color: #ffffff;
      }
    }

    .vip-pane-tab-li:nth-child(1).is-active {
      padding-right: 50px;
    }

    .vip-pane-tab-li:nth-child(2).is-active {
      padding-left: 50px;
    }

    .vip-pane-tab-li.is-active::after {
      // 三角形
      content: "";
      position: absolute;
      top: 2px;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;
      border-bottom: 74px solid #fff;
    }

    .vip-pane-tab-li:nth-child(1).is-active::after {
      right: -20px;
    }

    .vip-pane-tab-li:nth-child(2).is-active::after {
      left: -20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vipPane.vue